/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.emoticon[_ngcontent-%COMP%]{font-size:2em}.emoticon.very-happy[_ngcontent-%COMP%]:before{content:\"\uD83D\uDE01\"}.emoticon.happy[_ngcontent-%COMP%]:before{content:\"\uD83D\uDE42\"}.emoticon.so-so[_ngcontent-%COMP%]:before{content:\"\uD83D\uDE10\"}.emoticon.sad[_ngcontent-%COMP%]:before{content:\"\uD83D\uDE14\"}.emoticon.very-sad[_ngcontent-%COMP%]:before{content:\"\uD83D\uDE23\"}.emoticon.disabled[_ngcontent-%COMP%]{color:grey;-webkit-filter:grayscale(100%);filter:grayscale(100%)}"];
export { styles as styles };
